import memoize from 'lodash/memoize';

var REGXP_SCROLL_HIDDEN = /(auto|scroll|hidden)/;
var REGXP_SCROLL = /(auto|scroll)/;
var mapOfParentScrollElement = new Map();
var getParentScrollElement = memoize(function (element) {
  var includeHidden = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (element) {
    if (mapOfParentScrollElement.has(element)) {
      return mapOfParentScrollElement.get(element) || null;
    }
    var style = getComputedStyle(element);
    if (style.position === "fixed") {
      return null;
    }
    var excludeStaticParent = style.position === "absolute";
    var overflowRegex = includeHidden ? REGXP_SCROLL_HIDDEN : REGXP_SCROLL;
    var parent;
    var parentElements = [];
    for (parent = element; parent;) {
      parentElements.push(parent);
      style = getComputedStyle(parent);
      if (excludeStaticParent && style.position === "static") {
        parent = parent.parentElement;
        continue;
      }
      if (mapOfParentScrollElement.has(parent)) {
        return mapOfParentScrollElement.get(parent) || null;
      }
      if (overflowRegex.test("".concat(style.overflow).concat(style.overflowY).concat(style.overflowX))) {
        parentElements.forEach(function (parentElement) {
          mapOfParentScrollElement.set(parentElement, parent);
        });
        return parent;
      }
      parent = parent.parentElement;
    }
  }
  return null;
});

export { getParentScrollElement };
